import React from "react";
import { CalendarDays } from "lucide-react";

export default function DateRangePicker({ startDate, endDate, onStartChange, onEndChange }) {
  return (
    <div className="flex items-center gap-2">
      <CalendarDays size={14} className="text-slate-400 flex-shrink-0" />
      <input
        data-testid="dashboard-date-start"
        type="date"
        value={startDate}
        onChange={(e) => onStartChange(e.target.value)}
        className="h-9 px-3 rounded-xl border border-slate-200 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      />
      <span className="text-slate-400 text-xs font-medium">to</span>
      <input
        data-testid="dashboard-date-end"
        type="date"
        value={endDate}
        min={startDate}
        onChange={(e) => onEndChange(e.target.value)}
        className="h-9 px-3 rounded-xl border border-slate-200 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      />
    </div>
  );
}
